import React, { useState } from "react";
import CustomModal from "../../components/modal/Modal";

const AnexoLink = ({ base64 }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const isBase64 = (str) => {
    const base64Regex =
      /^(data:(image\/[a-zA-Z]*|application\/pdf);base64,)?([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
    return base64Regex.test(str);
  };

  const base64toBlob = (base64) => {
    const base64Parts = base64.split(";base64,");
    const contentType = base64Parts[0].split(":")[1];
    const byteCharacters = atob(base64Parts[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: contentType });
    return blob;
  };

  const openBase64PdfInNewTab = (base64) => {
    if (isBase64(base64) && base64.startsWith("data:application/pdf")) {
      const blob = base64toBlob(base64);
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } else {
      handleOpenModal("Erro ao abrir anexo", "O anexo não é um PDF válido.");
    }
  };

  return (
    <>
      <p>
        <strong>Anexo: </strong>
        <a href="#!" onClick={() => openBase64PdfInNewTab(base64)}>
          clique aqui para acessar o anexo
        </a>
      </p>
      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default AnexoLink;
